import React from "react";
import { Col } from "react-bootstrap";
import { Image } from "react-bootstrap";
import Logo from "../../assets/images/logo.png";
import sign_img from "../../assets/images/sign_img.png";
import { HiOutlineClipboardCheck } from "react-icons/hi";
import { MdChecklist, MdOutlineAutoGraph } from "react-icons/md";
import { GetPageTittle } from "../../services/utils";
import { useNavigate } from "react-router-dom";
export default function RightSidebar(props) {
    const now = GetPageTittle()
    const navigate = useNavigate()

    return (
        <Col md={6} className="pe-0 sticky_col">
            <div className="signuprt_div">
                <div className="sign_logo mb-4">
                    <a onClick={() => (navigate("/"))}>
                        <Image src={Logo} fluid />
                    </a>
                </div>
                {props.step &&
                    <h6 className="mb-4">Step {props.step} of {((now === 'School') || (now === 'Hospital')) ? 3 : 5} </h6>
                }
                <div className="sign_img">
                    <Image src={sign_img} fluid />
                </div>

                

                <div className="wb_ftrs">
                    <ul>
                        <li>
                            <div className="prnt_ftr">
                                <span className="ftr_icn">
                                    <MdOutlineAutoGraph />
                                </span>
                                <span>
                                    Streamlined and High
                                    efficiency
                                </span>
                            </div>
                        </li>
                        <li>
                            <div className="prnt_ftr">
                                <span className="ftr_icn">
                                    <MdChecklist />
                                </span>
                                <span>
                                    Organized and Comprehensive
                                </span>
                            </div>
                        </li>
                        <li>
                            <div className="prnt_ftr">
                                <span className="ftr_icn">
                                    <HiOutlineClipboardCheck />
                                </span>
                                <span>
                                    HIPAA and FERPA Compliant
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </Col >
    )
}